import React from 'react';
import PropTypes from 'prop-types';

export default function Collapisble({ header, content, headerId }) {
  const [ isActive, setIsActive ] = React.useState(headerId === 'default');
  return (
    <React.Fragment>
      <h4 className={`collapsible ${headerId} # ${isActive ? 'active' : ''}`} onClick={() => {
        setIsActive(!isActive);
      }
      }>{header}</h4>

      <div className="content" style={{ display: isActive ? 'block' : 'none' }}>
        {content}
      </div>
    </React.Fragment>
  );
}

Collapisble.propTypes = {
  header: PropTypes.string.isRequired,
  content: PropTypes.element.isRequired,
  headerId: PropTypes.string.isRequired,
};
